const GALLERY_LIGHTBOX_TRANSITION_DURATION = 300;
const GALLERY_LIGHTBOX_SCROLL_DURATION = 20;

class ProductGalleryLightbox extends ModalBase {
  get modalTransition() {
    return {
      overlayOpenClasses: ['opacity-100'],
      overlayClosedClasses: ['opacity-0'],
      panelOpenClasses: ['opacity-100', 'scale-100'],
      panelClosedClasses: ['opacity-0', 'scale-95'],
      transitionDuration: GALLERY_LIGHTBOX_TRANSITION_DURATION,
    };
  }

  constructor() {
    super();
    this.previousActiveElement = null;
    this.isOpen = false;
    this.focusTrapHandler = null;
    this.embla = null;
  }

  connectedCallback() {
    this.overlay = this.querySelector('[data-gallery-lightbox-overlay]');
    this.panel = this.querySelector('[data-gallery-lightbox-panel]');
    this.track = this.querySelector('[data-gallery-lightbox-track]');
    this.slides = [...this.querySelectorAll('[data-gallery-lightbox-slide]')];
    this.prevButton = this.querySelector('[data-gallery-lightbox-prev]');
    this.nextButton = this.querySelector('[data-gallery-lightbox-next]');

    if (this.track && typeof EmblaCarousel !== 'undefined' && this.slides.length > 0) {
      this.embla = EmblaCarousel(this.track.parentElement, {
        loop: true,
        align: 'center',
        duration: GALLERY_LIGHTBOX_SCROLL_DURATION,
      });

      this.prevButton?.addEventListener('click', () => this.embla.scrollPrev());
      this.nextButton?.addEventListener('click', () => this.embla.scrollNext());
      this.embla.on('select', () => this.loadAround(this.embla.selectedScrollSnap()));
    }

    this.overlay?.addEventListener('click', () => this.close());

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-gallery-lightbox-close]')) this.close();
    });

    this.handleKeydown = (event) => {
      if (!this.isOpen) return;
      if (event.key === 'Escape') this.close();
      if (event.key === 'ArrowLeft') this.embla?.scrollPrev();
      if (event.key === 'ArrowRight') this.embla?.scrollNext();
    };
    document.addEventListener('keydown', this.handleKeydown);

    this.handleTriggerClick = (event) => {
      const trigger = event.target.closest('[data-gallery-lightbox-trigger]');
      if (trigger) this.openWithTrigger(trigger);
    };
    document.addEventListener('click', this.handleTriggerClick);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('click', this.handleTriggerClick);
    this.embla?.destroy();
    this.removeTrapFocus();
  }

  // Load the opened slide and its neighbours now so none of them pops in while navigating.
  loadAround(index) {
    const count = this.slides.length;
    for (const offset of [0, 1, -1]) {
      const image = this.slides[(index + offset + count) % count]?.querySelector('img');
      if (!image) continue;
      image.loading = 'eager';
      if (offset === 0) image.fetchPriority = 'high';
    }
  }

  openWithTrigger(trigger) {
    const { mediaId } = trigger.dataset;
    const index = this.slides.findIndex((slide) => slide.dataset.mediaId === mediaId);
    const targetIndex = index === -1 ? 0 : index;

    this.loadAround(targetIndex);

    // The panel has a fixed CSS size, so Embla measures correctly as soon as it is unhidden.
    this.openModal(() => {
      if (!this.embla) return;
      this.embla.reInit();
      this.embla.scrollTo(targetIndex, true);
    });
  }

  close() {
    this.closeModal();
  }
}

if (!customElements.get('product-gallery-lightbox')) {
  customElements.define('product-gallery-lightbox', ProductGalleryLightbox);
}
